import React, { useState, useEffect, useMemo } from 'react'
import axios from 'axios'
import DataTable from 'react-data-table-component'
import {
  Container,
  Row,
  Col,
  Badge,
  Spinner,
  Alert,
  Form,
} from 'react-bootstrap'
import { FaSortUp, FaSortDown } from 'react-icons/fa'
import { MdPending } from 'react-icons/md'
import TmsHeader from '../TmsComponents/TmsHeader'
import TmsSidebar from '../TmsComponents/TmsSidebar'
import { useNavigate } from 'react-router-dom'

const UpcomingTraining = () => {
  const [trainings, setTrainings] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [search, setSearch] = useState('')
  const [sortDirection, setSortDirection] = useState('asc')
  const URL = 'https://tdtlworld.com/dss-kaas-backend/tms/training/Upcoming/'

  const navigate = useNavigate()

  useEffect(() => {
    const fetchTrainings = async () => {
      const token = localStorage.getItem('jwttoken')
      setLoading(true)
      try {
        const response = await axios.get(URL, {
          headers: { Authorization: `Bearer ${token}` },
        })
        setTrainings(response.data)
      } catch (error) {
        console.error('Error fetching training data', error)
        setError('Failed to load training data. Please try again later.')
      } finally {
        setLoading(false)
      }
    }
    fetchTrainings()
  }, [])

  const handleSearch = (event) => {
    setSearch(event.target.value)
  }

  const filteredEvents = useMemo(() => {
    return trainings.filter((e) =>
      e.title.toLowerCase().includes(search.toLowerCase())
    )
  }, [trainings, search])

  const sortedEvents = useMemo(() => {
    return [...filteredEvents].sort((a, b) => {
      const modifier = sortDirection === 'asc' ? 1 : -1
      return modifier * a.title.localeCompare(b.title)
    })
  }, [filteredEvents, sortDirection])

  const sortIcon = sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />

  const columns = [
    {
      name: 'ID',
      selector: (row) => row.training_id,
      sortable: true,
      width: '8%',
    },
    {
      name: 'Name',
      selector: (row) => row.title,
      sortable: true,
      width: '13%',
    },
    {
      name: 'Client',
      selector: (row) => row.client,
      sortable: true,
      width: '13%',
    },
    {
      name: 'Event',
      selector: (row) => `${row.start_date}`,
      sortable: true,
      width: '16%',
    },
    {
      name: 'Batch Size',
      selector: (row) => (
        <Badge
          pill
          bg='danger'
          style={{
            padding: '0.25em',
            fontSize: '0.75em',
            width: '24px',
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {row.max_participants}
        </Badge>
      ),
      sortable: true,
      width: '10%',
    },
    { name: 'BY', selector: (row) => row.by, sortable: true, width: '10%' },
    {
      name: 'Created On',
      selector: (row) => row.created_on,
      sortable: true,
      width: '10%',
    },
    {
      name: 'Status',
      selector: (row) => (
        <Badge pill bg='info' style={{ color: '#fff', fontSize: '0.8em' }}>
          <MdPending style={{ marginRight: '3px', verticalAlign: 'middle' }} />{' '}
          {row.status}
        </Badge>
      ),
      width: '10%',
    },
    {
      name: 'Action',
      cell: (row) => (
        <span
          onClick={() => handleActionClick('View Event', row)}
          style={{
            color: '#6a1b9a',
            cursor: 'pointer',
            fontWeight: '500',
            fontSize: '0.85em',
          }}
        >
          View Event
        </span>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '8%',
    },
  ]

  const customStyles = {
    tableWrapper: {
      style: {
        borderRadius: '10px',
        overflowX: 'hidden',
      },
    },
    headRow: {
      style: {
        backgroundColor: '#f8f9fa',
        fontSize: '0.85em',
        fontWeight: '500',
        color: '#495057',
      },
    },
    rows: {
      style: {
        fontSize: '0.8em',
        color: '#343a40',
        borderBottom: '1px solid #dee2e6',
        '&:hover': {
          backgroundColor: '#f1f3f5',
        },
      },
    },
    pagination: {
      style: {
        borderTop: '1px solid #dee2e6',
        paddingTop: '0.5em',
      },
    },
  }

  const handleActionClick = (action, row) => {
    navigate(`/viewevent/${row.training_id}`)
  }

  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <TmsSidebar />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <TmsHeader />
        <Container fluid className='py-4'>
          <Row className='justify-content-center'>
            <Col
              lg={12}
              className='shadow p-4 rounded'
              style={{ backgroundColor: '#ffffff', borderRadius: '10px' }}
            >
              <h4 className='text-center mb-4'>Upcoming Training List</h4>
              {error && (
                <Alert variant='danger' className='text-center'>
                  {error}
                </Alert>
              )}
              <Row className='mb-3'>
                <Col md={6}>
                  <Form.Control
                    className='rounded'
                    type='text'
                    placeholder='Search by title'
                    value={search}
                    onChange={handleSearch}
                    style={{ fontSize: '0.85em' }}
                  />
                </Col>
              </Row>
              {loading ? (
                <div className='text-center'>
                  <Spinner animation='border' variant='primary' />
                </div>
              ) : (
                <DataTable
                  columns={columns}
                  data={sortedEvents}
                  striped
                  dense
                  pagination
                  highlightOnHover
                  customStyles={customStyles}
                  sortIcon={sortIcon}
                  onSort={(_, direction) => setSortDirection(direction)}
                />
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  )
}

export default UpcomingTraining
